export const jsonPlaceholderUrl = 'https://jsonplaceholder.typicode.com';
export const jsonServerUrl = 'https://my-json-server.typicode.com';



export const spotTrackingImageDefault  ='https://vertice-ds.s3.amazonaws.com/Assets/Images/fallbacks/fallback-img-store.png';
export const BannerType = {
  desktop: 1,
  mobile: 2,
  tablet: 3,
};

export const showCaseApiURL = process.env.REACT_APP_SHOWCASE_API_ENDPOINT;
export const redemptionsApiUrl =
  process.env.REACT_APP_PREMMIAR_REDEMPTION_API_ENDPOINT;
export const ltmApiURL = process.env.REACT_APP_CLOUD_LOYALTY_ENDPOINT;

export const showCaseAutomateApiURL =
  process.env.REACT_APP_SHOWCASE_AUTOMATE_API_ENDPOINT;

export const genericSupplierApiURL =
  process.env.REACT_APP_GENERIC_SUPPLIER_API_ENDPOINT;

export const senderConciergeEmailApiURL =
  process.env.REACT_APP_CONCIERGE_SEND_EMAIL_ENDPOINT;

export const shellSupplierId = 117;

export const conciergeApiURL = process.env.REACT_APP_REDEMPTION_CONCIERGE_API_ENDPOINT;
export const participantGroupApiUrl = process.env.REACT_APP_PARTICIPANT_GROUP_API_ENDPOINT;

export const couponVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.9 },
};

export const focalPointApiURL = process.env.REACT_APP_FOCALPOINT_API_ENDPOINT;


export const emptyCart = 'https://vertice-ds.s3.amazonaws.com/Assets/Images/icons/empty_cart.svg';
export const GTM_CONTAINER_DEFAULT = 'GTM-TBVGFHQ';
